import axiosInstance from '../config/axios.js';

const API_BASE = '/company-settings';

const companySettingsService = {
  // Get current company's settings (backend auto-creates defaults if missing)
  getSettings: async (companyId = null) => {
    const params = companyId ? { company_id: companyId } : {};
    const response = await axiosInstance.get(API_BASE, { params });
    return response.data;
  },

  // Update settings (currently the RCM config)
  updateSettings: async (payload, companyId = null) => {
    const params = companyId ? { company_id: companyId } : {};
    const response = await axiosInstance.put(API_BASE, payload, { params });
    return response.data;
  },
};

export default companySettingsService;
